import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import BackgroundImage from 'gatsby-background-image'

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import Header from "./../../../components/header"
import ListItem from "./../../../components/ListItem"
import BadgeItem from "./../../../components/BadgeItem"
import BackButton from "./../../../components/BackButton"
import Album from "./../../../components/Album"

export default class Nizwa extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  toggleOpen = () => {
    this.setState((state, props) => ({
      open: !state.open,
    }));
  }

  render() {
    const data = this.props.data;
    return (
      <Layout>
        <Header title="Retour" href="/estacades" />
        <SEO title="Nizwa" />

        <BackgroundImage
          className="banner"
          fluid={[
            'linear-gradient(transparent, #101010 90%)',
            data.bg.childImageSharp.fluid,
          ]}
        >
          <h1>Nizwa</h1>
        </BackgroundImage>

        <p>Le 25 juin 2014, Nizwa, boutre arabe est arrivé dans le Port Rhu à Douarnenez. Ce bateau privé est depuis amarré au sein de l’espace à flot du Port-musée.</p>

        {this.state.open ? <div dangerouslySetInnerHTML={{ __html: data.learnMore.html }} /> : <p className="learn-more" onClick={this.toggleOpen}>En savoir plus</p>}

        <Album slides={data.photos} />

        <BackButton />

      </Layout>
    )
  }
}

export const query = graphql`
  query {
    bg: file(relativePath: { eq: "estacades/nizwa/nizwa.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    learnMore: markdownRemark(fileAbsolutePath: {regex: "/nizwa.md/"}) {
      html
    }
    photos: allFile(
      filter: {relativeDirectory: {regex: "/estacades/nizwa/photos/"}},
      sort: {fields: name}
    ) {
      edges {
        node {
          id
          childImageSharp {
            fluid(maxWidth: 360) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
